import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainNavbar from './components/helpers/Navbar';
import Home from './pages/Home';
import ProiectLegeMagistratiPage from './pages/ProiectLegeMagistrati';
import ProiectDigitalPentruBinePage from './pages/ProiectDigitalPentruBine';
import ProiectPlamanulVerdeAlOrasuluiPage from './pages/ProiectPlamanulVerdeAlOrasului';
import Footer from './components/helpers/Footer';
import Contact from './pages/Contact';
import Gdpr from './pages/Gdpr';
import ProiectUnited from './pages/ProiectUnited';

function App() {
  return (
    <div className="bg-light min-vh-100">
      <Router>
        <MainNavbar />
        <Routes>
          <Route path="/" element={<Home />} />
           {/* <Route path="/proiect-lege-magistrati" element={<ProiectLegeMagistratiPage />} /> */}
          <Route path="/digital-pentru-bine" element={<ProiectDigitalPentruBinePage />} />
          <Route path="/plamanul-verde-al-orasului" element={<ProiectPlamanulVerdeAlOrasuluiPage />} />
          <Route path="/united-romania-globala" element={<ProiectUnited />} />
          <Route path="/contact" element={<Contact />} /> 
          <Route path="/gdpr" element={<Gdpr />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;

